import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

export default function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    usertype: "user",
    status: 1
  });

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}users/fetchuser_byid/${id}`
      );

      setFormData(result.data.data);

    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}users/updateuser/${id}`,
        formData
      );

      alert("User updated successfully");

      navigate("/users");

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="main-card">
      <div className="table-header-panel">
        Edit User
      </div>

      <form onSubmit={handleSubmit} className="p-4">

        <div className="mb-3">
          <label>Username</label>
          <input
            className="form-control"
           value={formData?.username || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                username: e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label>Email</label>
          <input
            className="form-control"
            value={formData?.email || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                email: e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label>User Type</label>
          <select
            className="form-control"
            value={formData?.usertype || "user"}
            onChange={(e) =>
              setFormData({
                ...formData,
                usertype: e.target.value
              })
            }
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
            <option value="contentadmin">Content Admin</option>
          </select>
        </div>

        <div className="mb-3">
          <label>Status</label>
          <select
            className="form-control"
            value={formData?.status ?? 1}
            onChange={(e) =>
              setFormData({
                ...formData,
                status: Number(e.target.value)
              })
            }
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button type="submit" className="btn btn-primary">
            Update User
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate("/users")}
          >
            Cancel
          </button>
        </div>

      </form>
    </div>
  );
}